module.exports = __webpack_public_path__ + "static/media/07_plantilla_rec_combo_simple_cp_stills_tetra_200_ades_manzana.19ac3030.png";